import { $api } from "../index";
import { ContactFormDTO } from "@generated/models/ContactFormDTO";

class MailService {
	static async sendContactForm(values: ContactFormDTO) {
		return await $api.post<void>("/mails/contactForm", values);
	}
}

export default MailService;
